import React from 'react';
import {
    Dialog,
    Button,
    DialogTitle,
    DialogContent,
    DialogActions,
} from '@mui/material';
import * as applicationService from 'services/application-service';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface IProps {
    open: boolean;
    handleClose: () => void;
    showMessage: MessageBox;
    applicationId: string | undefined;
}

const DeleteModal = (props: IProps) => {
    const {
        open,
        handleClose,
        applicationId,
        showMessage,
    } = props;
    const navigate = useNavigate();
    const { t } = useTranslation();

    const handleDelete = () => {
        if (applicationId) {
            applicationService.deleteApplication(applicationId).then(() => {
                navigate('/beheer/aanvragen')
                showMessage('Aanvraag verwijderd', 'success', 5000);
            }).catch((error) => {
                const {
                    response: {
                        data: {
                            error: {
                                message
                            }
                        }
                    }
                } = error;
                showMessage(message, 'error', 5000);
            });
        }
    }

    return (
        <Dialog fullWidth open={open} onClose={handleClose}>
            <DialogTitle>{t('requestWithDetail.delete.title')}</DialogTitle>
            <DialogContent>
                {t('requestWithDetail.delete.description')}
            </DialogContent>
            <DialogActions>
                <Button variant='contained' onClick={handleClose} color='cancel'>
                    {t("buttons.cancel")}
                </Button>
                <Button variant='contained' onClick={handleDelete} color='delete'>
                    {t("requestWithDetail.deleteButton")}
                </Button>
            </DialogActions>
        </Dialog>
    )
};

export default DeleteModal;